import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Headphones } from "lucide-react";
import { addNewStyle, CRISTP_ID, wait } from "../../../Helper";
import "./sidebarHello.css";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { TbWorld } from "react-icons/tb";
import storage from "../../../Storage";
import axios from "axios";

const SupportButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #323738;
  border: none;
  width: 200px;
  border-radius: 10px;
  padding-right: 20px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #323738;
  }
`;

const IconWrapperSupport = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #57d219;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;
const IconWrapperTelegram = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #24a1de;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;

const Text = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  margin: 0px 12px;
`;

const Title = styled.div`
  color: #9ca3af;
  font-size: 14px;
  margin-left: 10px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3c4142;
  color: white;
  padding: 10px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: linear-gradient(
      to left,
      #323738,
      rgb(204, 120, 0)
    ); /* Apply hover effect here */
  }
`;

const ButtonText = styled.span`
    font-size: 14px;
    display: ${(props) => (props.isCollapsed ? "none" : "block")};
   
  }
  `;

const StyledChevronRight = styled(ChevronRight)`
  color: #9ca3af;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const SidebarContainer = styled.nav`
  color: rgba(153, 164, 176, 0.8);
  background-color: #292d2e;
  transition: 0.2s linear;
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  height: 100vh;
  padding: ${(props) => (props.isCollapsed ? "12px 0px" : "12px 0px")};
  color: #ffffff;
  position: fixed;
  top: -12px;
  left: 0;
  z-index: 999;
  transition: width 0.3s ease;
  overflow-y: auto;
`;

// const SidebarTop = styled.div`
//   background-color: #292d2e;
//   width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
//   padding: ${(props) => (props.isCollapsed ? "20px" : "9px")};
//   box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
//   color: #fff;
//   display: flex;

//   position: fixed;
//   top: 0px;
//   z-index: 9999;
// `;
const SidebarTop = styled.div`
  background-color: #292d2e;
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  padding: ${(props) => (props.isCollapsed ? "20px" : "6px")};
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  display: flex;
  height: 60px;
  position: fixed;
  top: 0px;
  z-index: 9999;
`;

const CircularBarContainer = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 5px;
  // background-color: rgb(26, 28, 32);
  background-color: #3a4142;
  box-shadow: transparent 0px 2px 4px 0px;
  z-index: 9999;
  position: absolute;
  top: 12px;
  padding: 5px;
  left: 18px;
  transition: right 0.2s linear;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white !important;
  font-size: 20px;
`;

const MenuItemLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${(props) => (props.color ? "white" : "white")};
  justify-content: center;
  justify-content: ${(props) =>
    props.isCollapsed ? "center" : "left "}!important;
  padding: ${(props) => (props.isCollapsed ? "2px" : "2px 8px")};
  cursor: pointer;
  position: relative;
  margin-top: 8px;
  // border:1px solid rgb(255, 168, 0);
  margin: ${(props) => (props.isCollapsed ? "3px" : "5px 7px")};
  border-radius: 5px;
  // background-color:#3c4142;
  background-color: #323738 !important;
  width: 93%;
  // border-top-right-radius: 20px;
  // border-bottom-right-radius: 20px;
  text-decoration: none;
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};

  &:hover {
    background: linear-gradient(
      to left,
      #323738,
      rgb(204, 120, 0)
    ); /* Apply hover effect here */
  }
  ${(props) =>
    !props.isCollapsed &&
    props.active &&
    `
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          color:white;
          // border:1px solid rgb(255, 168, 0);
          border-radius:5px;
          // margin:0px 5px;
          background: linear-gradient(to left, #323738, rgb(204, 120, 0));
          // background-color: rgba(76,175,80,0.2);
          // border-top-right-radius: 20px;
          // border-bottom-right-radius: 20px;

        }
      `}

  ${(props) =>
    props.isCollapsed &&
    `
        justify-content: center;
        padding: 8px 0;
        color:white;
        
      `}
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.isCollapsed ? "0" : "3px")};
  position: relative;
  z-index: 1;

  ${(props) =>
    props.isCollapsed &&
    props.active &&
    `
        background-color: #2E3238;
        border-radius: 50%;
        width: 50px;
        height: 50px;
      `}
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const Label = styled.span`
  font-size: ${(props) => (props.isVIP || props.isPromotion ? "16px" : "14px")};
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) =>
    props.isVIP || props.isPromotion ? "italic" : "normal"};
  position: relative;
  z-index: 1;

  color: ${(props) => {
    if (props.isVIP) return "#EB5D0E";
    if (props.isPromotion) return "#5DDB1B";
    return "#808A94";
  }} !important;
  display: ${(props) => (props.isCollapsed ? "none" : "inline")};
`;

const Divider = styled.div`
  height: 1px;
  background-color: #353535;
  margin: 8px ${(props) => (props.isCollapsed ? "4px" : "16px")};
`;

const SwitcherContainer = styled.div`
  display: flex;

  // border-radius: 9999px;
  text-align: end;
  // padding: 4px;
`;

const Tab = styled.div`
  width: 100%;

  // padding: 8px 28px;
  // border-radius: 9999px;
  // font-size: 14px;
  // font-weight: 500;
  // transition: background-color 0.3s, color 0.3s;
`;

const DropdownMenu = styled.div`
  align-items: center;
  color: white;
  padding: 2px 8px;
  cursor: pointer;
  position: relative;
  // margin-top: 8px;
  margin: 5px 7px;
  border-radius: 5px;
  // background-color: #3c4142;
  width: 93%;

  // border:1px solid brown;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  justify-content: center;
  padding: 2px 0px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  // background-color: #3a4142;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-top: -7px;
  // margin-left: 10px;
  // margin-right: 10px
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};
`;

const DropdownItem = styled(Link)`
  display: block;
  color: white;
  padding: 15px 12px;
  textalign: center;
  text-decoration: none;
  border-radius: 5px;
  background-color: #3c4142;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(to left, #323738, rgb(204, 120, 0));
  }
`;

const SidebarHello = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Casino");
  const tabs = ["Casino", "Sports"];
  const [lotteryDropdownOpen, setLotteryDropdownOpen] = useState(true); // State to control dropdown
  const [casinoSubmenuOpen, setCasinoSubmenuOpen] = useState(true);
  const [sportsSubmenuOpen, setSportsSubmenuOpen] = useState(false);

  const [settings, setSettings] = useState();

  const [loaded, setLoaded] = useState(false);

  const casinoSubmenu = [
    {
      name: "Originals",
      icon: "/assets/bcimages/sidebar/bc-original.svg",
      path: "/casino/originals",
    },
    {
      name: "Hot Games",
      icon: "/assets/bcimages/sidebar/icon/hot-games.svg",
      path: "/casino/hot-games",
    },
    {
      name: "Slots",
      icon: "/assets/bcimages/sidebar/icon/slot.svg",
      path: "/casino/slots",
    },
    {
      name: "Live Casino",
      icon: "/assets/bcimages/sidebar/icon/live-casino.svg",
      path: "/casino/live-casino",
    },
    {
      name: "New Release",
      icon: "/assets/bcimages/sidebar/icon/newRealease.svg",
      path: "/casino/new-release",
    },
    {
      name: "Feature Buy-In",
      icon: "/assets/bcimages/sidebar/icon/featurebuyin.svg",
      path: "/casino/featurebuy",
    },
    {
      name: "Provider",
      icon: "/assets/bcimages/sidebar/icon/providers.svg",
      path: "/casino/provider",
    },
    {
      name: "Top Picks",
      icon: "/assets/bcimages/sidebar/icon/top-picks.svg",
      path: "/casino/top-picks",
    },
    {
      name: "Theme",
      icon: "/assets/bcimages/sidebar/icon/theme.svg",
      path: "/casino/theme",
    },
  ];

  const sportsSubmenu = [
    {
      name: "Cricket",
      icon: "/assets/bcimages/sidebar/icon/cricket.svg",
      path: "/sports/cricket",
    },
    {
      name: "Football",
      icon: "/assets/bcimages/sidebar/icon/football.svg",
      path: "/sports/football",
    },
    {
      name: "Soccer",
      icon: "/assets/bcimages/sidebar/icon/soccer.svg",
      path: "/sports/soccer",
    },
    {
      name: "Basketball",
      icon: "/assets/bcimages/sidebar/icon/basketball.svg",
      path: "/sports/basketball",
    },
    {
      name: "Tennis",
      icon: "/assets/bcimages/sidebar/icon/tennis.svg",
      path: "/sports/tennis",
    },
    {
      name: "Baseball",
      icon: "/assets/bcimages/sidebar/icon/baseball.svg",
      path: "/sports/baseball",
    },
    {
      name: "Hockey",
      icon: "/assets/bcimages/sidebar/icon/hockey.svg",
      path: "/sports/hockey",
    },
  ];

  const support = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;

    if (!loaded) {
      console.log("support");
      setLoaded(true);
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      document.head.appendChild(script);
    }

    addNewStyle("#crisp-chatbox {display:block !important;}");
    addNewStyle(
      ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
    );

    wait(2000).then(() => {
      const close = document.querySelector(".cc-wdhl");
      if (close === null) return;
      close.addEventListener("click", function (event) {
        addNewStyle("#crisp-chatbox {display:none !important;}");
        document.getElementById("chtt").src = "";
      });
    });
  };

  const fetchSettings = async () => {
    try {
      const response = await axios.get("https://api.betbazaar365.com/setting");

      const data = response?.data;

      if (data) {
        setSettings(data?.data[0]); // ✅ Uncommented to actually
      }
    } catch (error) {
      console.error("Error fetching payment settings:", error);
    }
  };

  useEffect(() => {
    const toggleValue = localStorage.getItem("isCollapsed");
    if (toggleValue !== null) {
      setIsCollapsed(toggleValue === "true");
    }

    fetchSettings();
  }, []);

  function telegramLink() {
    // console.log(settings)
    window.location.href = settings?.telegram_link;
  }

  const toggleSidebar = () => {
    const newIsCollapsed = !isCollapsed;
    setIsCollapsed(newIsCollapsed);
    localStorage.setItem("isCollapsed", newIsCollapsed.toString());
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "Casino") {
      setCasinoSubmenuOpen(true);
      setSportsSubmenuOpen(false);
    } else if (tab === "Sports") {
      setCasinoSubmenuOpen(false);
      setSportsSubmenuOpen(true);
    }
  };

  const menuItems = [
    {
      name: "Home ",
      icon: "/assets/bcimages/sidebar/coin-logo-bc338b33 (1).png",
      path: "/",
    },
    {
      name: "Original",
      icon: "/assets/bcimages/sidebar/svgexport-1.svg",
      path: "",
      hasSubMenu: true,
      subMenu: [
        {
          name: "Crash",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/crash",
        },
        {
          name: "Keno Multiplayer",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/keno",
        },
        {
          name: "Hashdice",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/hash-dice",
        },
        {
          name: "Hilo",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/hilo",
        },
        {
          name: "Blackjack",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/blackjack",
        },
        {
          name: "Mine",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/mine",
        },
        {
          name: "Keno",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/singlekeno",
        },
        {
          name: "Keno Goal",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/goal",
        },
        {
          name: "Video Poker",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/videopoker",
        },
        {
          name: "3 Card Monte",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/3-card-monte",
        },
        {
          name: "Tower Legend",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/tower",
        },
        {
          name: "Super Diamond",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/diamond",
        },
        {
          name: "Limbo",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/limbo",
        },
        {
          name: "Classic Dice",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/classic-dice",
        },
        {
          name: "Plinko",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/plinko",
        },
        {
          name: "Wheel",
          icon: "/assets/bcimages/Casino/slot.svg",
          path: "/wheel",
        },
      ],
    },

    { divider: true },
    // { name: 'Most Populars', icon: 'https://static.nanogames.io/assets/myfavorite.466f0741.png', path: '/populars' },
    // {
    //   name: "Rakeback",
    //   icon: "/assets/bcimages/sidebar/Lottery.svg",
    //   path: "/rakeback",
    // },
    {
      name: "Promotions",
      icon: "/assets/bcimages/sidebar/promotion.svg",
      color: "rgb(93, 219, 28)",
      path: "/promotions",
    },
    {
      name: "Affiliate",
      icon: "/assets/bcimages/sidebar/affiliate.svg",
      path: "/affiliate",
    },
    {
      name: "VIP Club",
      icon: "/assets/bcimages/sidebar/vip.svg",
      color: "rgb(235, 93, 15)",
      path: "/vip-club",
    },
    // {
    //   name: "Bonus",
    //   icon: "/assets/bcimages/sidebar/bonus.svg",
    //   color: "rgb(235, 93, 15)",
    //   path: storage.getKey("logged") ? "/bonus" : "/bonusSignup",
    // },

    { divider: true },

    {
      name: "Provably Fair",
      icon: "/assets/bcimages/sidebar/probablyfair.svg",
      color: "rgb(235, 93, 15)",
      path: "/provably-fair",
    },

    { divider: true },
    // {
    //   name: "About Us",
    //   icon: "https://static.nanogames.io/assets/myfavorite.466f0741.png",
    //   color: "rgb(93, 219, 28)",
    //   path: "/about-us",
    // },
    // {
    //   name: "Live Support",
    //   icon: <svg class="icon text-secondary size-6" viewBox="0 0 32 32"><path d="M12.0434 17.0183C12.9801 17.0183 13.7395 17.7778 13.7395 18.7145V25.3283C13.7395 26.265 12.9801 27.0244 12.0434 27.0244H10.2648C8.85937 27.0244 7.721 25.8852 7.721 24.4806V19.5629C7.721 18.1575 8.86019 17.0191 10.2648 17.0191H12.0434V17.0183ZM21.8077 17.0183C23.2132 17.0183 24.3515 18.1575 24.3515 19.5621V24.4798C24.3515 25.8852 23.2123 27.0236 21.8077 27.0236H20.0291C19.0925 27.0236 18.333 26.2641 18.333 25.3275V18.7136C18.333 17.777 19.0925 17.0175 20.0291 17.0175L21.8077 17.0183ZM15.9999 4.97559C22.6881 4.97559 28.1292 10.2983 28.2926 16.9261L28.2966 17.2331V22.2398C28.2966 22.9307 27.7348 23.4909 27.0415 23.4909C26.3915 23.4909 25.8574 22.9985 25.7929 22.368L25.7863 22.2398V17.2331C25.7863 11.845 21.4043 7.47772 15.9991 7.47772C10.6853 7.47772 6.36132 11.6988 6.21596 16.9603L6.21188 17.2331V22.2553C6.21188 22.9462 5.65004 23.5064 4.95673 23.5064C4.30669 23.5064 3.77262 23.014 3.70893 22.3835L3.70239 22.2553V17.2331C3.70239 10.4641 9.20807 4.9764 15.9991 4.9764L15.9999 4.97559Z"></path></svg>",
    //   // path: "/faq",
    // },
  ];

  return (
    <SidebarContainer isCollapsed={isCollapsed}>
      <SidebarTop>
        <CircularBarContainer onClick={toggleSidebar}>
          <img
            src="/assets/bcimages/sidebar/bcmenu.svg"
            width={24}
            height={24}
          />
        </CircularBarContainer>

        <SwitcherContainer style={{ margin: "4px" }}>
          <div className="bc-logo">
            <img
              src="/assets/bcimages/assamgames.png"
              className="bc-logo"
              style={{ width: "170px", paddingLeft: "50px" }}
            />
          </div>
        </SwitcherContainer>
      </SidebarTop>

      <div style={{ marginTop: "70px" }}>
        {menuItems.map((item, index) =>
          item.divider ? (
            <></>
          ) : item.hasSubMenu ? (
            <div key={`divider-${item.name}-${index}`}>
              <MenuItemLink
                to={item.path}
                active={
                  location.pathname === item.path ||
                  item.subMenu.some(
                    (subItem) => location.pathname === subItem.path
                  )
                } // Check if the current path matches the parent or any submenu path
                color={item.color}
                isCollapsed={isCollapsed}
                style={{ padding: "0px 13px" }}
                onClick={() => setLotteryDropdownOpen(!lotteryDropdownOpen)} // Toggle dropdown on click
              >
                <IconWrapper
                  active={
                    location.pathname === item.path ||
                    item.subMenu.some(
                      (subItem) => location.pathname === subItem.path
                    )
                  }
                  isCollapsed={isCollapsed}
                >
                  <Icon
                    src={item.icon}
                    alt={item.name}
                    style={{ width: "25px", height: "25px" }}
                  />
                </IconWrapper>

                <Label
                  active={
                    location.pathname === item.path ||
                    item.subMenu.some(
                      (subItem) => location.pathname === subItem.path
                    )
                  }
                  isCollapsed={isCollapsed}
                  style={{ width: "100%", justifyItems: "end" }}
                >
                  <span
                    className="game-fonts"
                    style={{
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {item.name}
                  </span>
                  {/* Arrow icon */}
                  <span
                    style={{
                      padding: "4px",
                      backgroundColor: "#464f50",
                      borderRadius: "3px",
                      marginLeft: "50%",
                      fontWeight: "bolder",
                    }}
                  >
                    <IoIosArrowDown
                      isOpen={lotteryDropdownOpen} // Pass the state for rotation
                      style={{
                        color: "white",
                        fontSize: "18px",
                        fontWeight: "bolder",
                        transition: "transform 0.3s ease", // Smooth transition
                        transform: lotteryDropdownOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)", // Rotate when open
                      }}
                    />
                  </span>
                </Label>
              </MenuItemLink>

              {/* Dropdown menu for the Lottery section */}
              <DropdownMenu isOpen={lotteryDropdownOpen}>
                {item.subMenu.map((subItem, subIndex) => (
                  <MenuItemLink
                    key={`sub-item-${subIndex}`}
                    to={subItem.path}
                    active={location.pathname === subItem.path} // Apply active state
                    style={{
                      padding: "4px 6.5px",
                      margin: "5px 0px",
                      width: "100%",
                      //  border:"1px solid pink",
                      backgroundColor:
                        location.pathname === subItem.path
                          ? "#333"
                          : "transparent",
                    }}
                  >
                    <IconWrapper>
                      <Icon
                        src={subItem.icon}
                        alt={subItem.name}
                        style={{ width: "25px", height: "25px" }}
                      />
                    </IconWrapper>
                    <Label
                      active={location.pathname === subItem.path}
                      isCollapsed={isCollapsed}
                    >
                      <span
                        className="game-fonts"
                        style={{
                          color: "white",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                      >
                        {subItem.name}
                      </span>
                    </Label>
                  </MenuItemLink>
                ))}
              </DropdownMenu>
            </div>
          ) : (
            <MenuItemLink
              key={item.name}
              to={item.path}
              active={location.pathname === item.path}
              color={item.color}
              isCollapsed={isCollapsed}
              style={{
                backgroundColor:
                  location.pathname === item.path ? "#333" : "transparent",
              }}
            >
              <IconWrapper
                active={location.pathname === item.path}
                isCollapsed={isCollapsed}
              >
                <Icon
                  src={item.icon}
                  alt={item.name}
                  style={{ width: "25px", height: "25px" }}
                />
              </IconWrapper>
              <Label
                active={location.pathname === item.path}
                isCollapsed={isCollapsed}
              >
                <span
                  className="game-fonts"
                  style={{
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {item.name}
                </span>
              </Label>
            </MenuItemLink>
          )
        )}

        {/* <Divider /> */}

        {/* <Flex style={{ marginTop: "15px", marginBottom: "15px" }}>
          <Container>
          
            <LanguageButton>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <TbWorld size={25} />

                <ButtonText
                  isCollapsed={isCollapsed}
                  className="game-fonts"
                  style={{ fontWeight: "bold" }}
                >
                  English
                </ButtonText>
              </div>

              <StyledChevronRight isCollapsed={isCollapsed} size={24} />
            </LanguageButton>
          </Container>
        </Flex> */}

        <Divider />

        <Flex
          onClick={support}
          style={{ marginTop: "10px", marginBottom: "20px" }}
        >
          <SupportButton style={{ width: "90%" }} onClick={telegramLink}>
            <IconWrapperTelegram>
              <img
                style={{ width: "30px" }}
                src="/assets/images/telegram.webp"
              />
            </IconWrapperTelegram>
            <Text isCollapsed={isCollapsed}>Telegram Support</Text>
          </SupportButton>
        </Flex>
        <Flex
          onClick={support}
          style={{ marginTop: "0px", marginBottom: "20px" }}
        >
          <SupportButton style={{ width: "90%" }}>
            <IconWrapperSupport>
              <Headphones size={18} color="white" />
            </IconWrapperSupport>
            <Text isCollapsed={isCollapsed}>Live Support</Text>
          </SupportButton>
        </Flex>
      </div>
    </SidebarContainer>
  );
};

export default SidebarHello;
